import { CcmStatuses, RpmStatuses } from 'infrastructure/enums';

import { usePatientInfo } from './use-patient-info';

interface Props {
  patientGuid: string;
}

export const TRACKING_PLATFORM_OPTIONS = [
  { label: 'RPM', value: 'RPM' },
  { label: 'CCM', value: 'CCM' },
];

export const useTrackingPlatform = ({ patientGuid }: Props) => {
  const { patientInfo } = usePatientInfo({ patientGuid });

  const isActiveOrPendingReview =
    patientInfo?.status === RpmStatuses.Active ||
    patientInfo?.status === RpmStatuses.PendingReview;
  const isCcmEnrolled = patientInfo?.ccmStatus === CcmStatuses.Enrolled;

  const showTrackingPlatform = isActiveOrPendingReview && isCcmEnrolled;

  const getTrackingPlatform = (formValue?: string | null) => {
    if (showTrackingPlatform) return formValue;
    if (isActiveOrPendingReview && !isCcmEnrolled) return 'RPM';
    if (!isActiveOrPendingReview && isCcmEnrolled) return 'CCM';
    return undefined;
  };

  return { showTrackingPlatform, getTrackingPlatform };
};
